module.exports = __webpack_public_path__ + "d9e214fe05897e46ad5658d1054d6cc3.pdf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/pdf/SanthoshRamaiahResumeIndia2017v1.0.pdf
 ** module id = 10
 ** module chunks = 0
 **/